module.exports = __webpack_public_path__ + "ye.20c6e27f.svg";